import type { ModulePage } from './types'

export const ramble: ModulePage = {
  slug: 'ramble',
  name: 'Ramble Dictation',
  tagline: 'Speak your thoughts. Watch them become tasks, notes and follow-ups.',
  icon: 'bolt',
  colorClass: 'ramble',
  pricingModules: ['dictations'],
  featured: true,

  seo: {
    title: 'Ramble: Voice Dictation for Advisers',
    description:
      'Dictate on the move, from your phone, Apple Watch or CarPlay, and Ramble turns your stream of thoughts into structured notes, tasks and client follow-ups.',
    keywords:
      'voice dictation financial advisers, adviser dictation app, hands-free notes, Apple Watch adviser notes',
  },

  hero: {
    eyebrow: 'Ramble Dictation',
    title: 'Just talk,',
    titleAccent: 'we’ll do the rest',
    subtitle:
      'Dictate into your phone, Apple Watch or CarPlay while it’s fresh. Ramble turns the ramble into organised notes, tasks and follow-ups by the time you’re back at your desk.',
  },

  useCases: [
    {
      icon: 'bolt',
      title: 'On the drive home',
      body: 'Capture everything from the meeting hands-free while it’s fresh, instead of losing it by the time you’re back.',
    },
    {
      icon: 'document',
      title: 'Between appointments',
      body: 'Fire off a quick voice note and let it land as tasks and notes against the right client.',
    },
    {
      icon: 'users',
      title: 'Client follow-ups',
      body: 'Speak the actions you promised and watch them become tracked follow-ups, not forgotten promises.',
    },
  ],

  benefits: [
    {
      icon: 'sparkle',
      title: 'Ramble in, structure out',
      body: 'Unstructured speech becomes clean notes, tasks and action items, automatically organised.',
    },
    {
      icon: 'mic',
      title: 'Capture anywhere',
      body: 'Phone, Apple Watch and CarPlay, so the moment of recall is never more than a tap away.',
    },
    {
      icon: 'bolt',
      title: 'Routed to the right place',
      body: 'Notes and tasks attach to the correct client and surface in your workflow without filing.',
    },
    {
      icon: 'document',
      title: 'No typing required',
      body: 'Turn dead time into done work: zero keyboard, zero admin backlog.',
    },
  ],

  stats: [
    { value: '0 typing', label: 'required' },
    { value: 'Hands-free', label: 'from watch or car' },
    { value: 'Instant', label: 'notes & tasks' },
  ],

  testimonial: {
    quote:
      'We have cut the time it takes to process a client. Being able to dictate notes and have the platform generate clear, consistent file notes has made my life so much easier.',
    author: 'Mike Haupt',
    role: 'Director',
    company: 'Haupt & Haupt FS',
  },

  cta: {
    title: 'Turn talk into',
    titleAccent: 'done work',
    subtitle: 'Dictate your next set of follow-ups and watch them organise themselves.',
    note: 'Included from the Professional plan. Start free.',
  },
}
